export interface OptionInfoView {
  id: string;
  name: string;
  description: string;
}

export interface OptionView {
  id: number;
  unitId: number;
  parentId: number | null;
  profondeur: number;
  name: string;
  points: OptionPointView | null;
  weight: number;
  quantity: number | null;
  isPerModel: boolean;
  maxSelectedChilds: number | null;
  minSelectedChilds: number;
  isMultiple: boolean;
  multiple: OptionMultipleView | null;
  status: OptionStatusView;
  infos: OptionInfoView[];
}

export interface OptionPointView {
  current: number;
  source: number;
  isLimit: boolean;
}

export const createDefaultOptionPointView = (
  points: number,
): OptionPointView => {
  return {
    current: points,
    source: points,
    isLimit: false,
  } satisfies OptionPointView as OptionPointView;
};

export interface OptionMultipleView {
  min: number;
  current: number;
  noLimit: boolean;
  max: number | null;
  delta: number | null;
}

export const createDefaultOptionMultipleView = (
  max: number,
): OptionMultipleView => {
  return {
    min: 0,
    current: 0,
    max: max,
    delta: max,
    noLimit: false,
  } satisfies OptionMultipleView as OptionMultipleView;
};

export interface OptionMultipleViewParams {
  min: number;
  current: number;
  noLimit: boolean;
  max: number | null;
  delta: number | null;
}

export class OptionStatusView {
  isVisible: boolean;
  canSelect: boolean;
  isChecked: boolean;
  isHidden: boolean;

  constructor(params: OptionStatusViewParams) {
    this.isVisible = params.isVisible;
    this.canSelect = params.canSelect ?? false;
    this.isChecked = params.isChecked ?? false;
    this.isHidden = params.isHidden ?? false;
  }

  static createDefault(): OptionStatusView {
    return new OptionStatusView({
      isVisible: true,
      canSelect: false,
      isChecked: false,
      isHidden: false,
    });
  }
}

export interface OptionStatusViewParams {
  isVisible: boolean;
  canSelect?: boolean;
  isChecked?: boolean;
  isHidden?: boolean;
}
